import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type RtuDetailChromeContextValue = {
  breadcrumbTrailingSlot: React.ReactNode | null;
  rtuBreadcrumbLabel: string | null;
  setBreadcrumbTrailingSlot: (node: React.ReactNode | null) => void;
  setRtuBreadcrumbLabel: (label: string | null) => void;
};

const RtuDetailChromeContext = createContext<RtuDetailChromeContextValue | null>(null);

export function RtuDetailChromeProvider({ children }: { children: React.ReactNode }) {
  const [breadcrumbTrailingSlot, setBreadcrumbTrailingSlotState] = useState<React.ReactNode | null>(null);
  const [rtuBreadcrumbLabel, setRtuBreadcrumbLabelState] = useState<string | null>(null);

  const setBreadcrumbTrailingSlot = useCallback((node: React.ReactNode | null) => {
    setBreadcrumbTrailingSlotState(node);
  }, []);

  const setRtuBreadcrumbLabel = useCallback((label: string | null) => {
    setRtuBreadcrumbLabelState(label);
  }, []);

  const value = useMemo(
    () => ({
      breadcrumbTrailingSlot,
      rtuBreadcrumbLabel,
      setBreadcrumbTrailingSlot,
      setRtuBreadcrumbLabel,
    }),
    [breadcrumbTrailingSlot, rtuBreadcrumbLabel, setBreadcrumbTrailingSlot, setRtuBreadcrumbLabel],
  );

  return <RtuDetailChromeContext.Provider value={value}>{children}</RtuDetailChromeContext.Provider>;
}

export function useRtuDetailChrome(): RtuDetailChromeContextValue {
  const ctx = useContext(RtuDetailChromeContext);
  if (!ctx) {
    return {
      breadcrumbTrailingSlot: null,
      rtuBreadcrumbLabel: null,
      setBreadcrumbTrailingSlot: () => {},
      setRtuBreadcrumbLabel: () => {},
    };
  }
  return ctx;
}
